<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="12">
        <div class="text-h4">{{ team.name }}</div>
        <div v-if="myReg?.isRegistered()">Registered as {{ myReg.teamLevel?.team_level }}</div>
        <div v-else>Not Registered</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="mb-6">
        <TeamLeaderCompontent :teamLeader="teamLeader"></TeamLeaderCompontent>
      </v-col>
      <v-col cols="12" md="6" class="mb-6">
        <TeamLogoCompontent
          :team="team"
          @logoUpdated="handleLogoUpdated"
          @snack="throwSnack"></TeamLogoCompontent>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card
          title="Team Info"
          subtitle="This info (website/socials/bio etc) may appear on 72Fest.com">
          <template v-slot:append>
            <v-btn variant="text" icon @click="isTeamEdit = !isTeamEdit">
              <v-icon icon="mdi-pencil">
                <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
              </v-icon>
            </v-btn>
          </template>
          <v-card-text v-if="!isTeamEdit">
            <TeamViewComponent :team="team"></TeamViewComponent>
          </v-card-text>
          <TeamEditComponent
            v-if="isTeamEdit"
            :team="team"
            :isCreate="false"
            :allow-close="true"
            @teamEditComplete="handleTeamEditComplete"
            @team-edit-canceled="isTeamEdit = false"
            @snack="throwSnack">
          </TeamEditComponent>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showTermsModal"
      fullscreen
      persistent
      scrollable
      transition="dialog-bottom-transition">
      <v-card class="d-flex flex-column" height="100vh">
        <v-card-text class="flex-grow-1 overflow-y-auto pa-0">
          <v-container fluid class="pa-5">
            <v-sheet class="border-opacity-25 border-thin rounded-lg pa-5">
              <v-row v-if="myReg?.isRegistered() && myReg?.force_redo_terms">
                <v-col cols="12">
                  <v-alert type="error" prominent>
                    You must re-accept the terms and conditions to continue.
                  </v-alert>
                </v-col>
              </v-row>

              <TermsView @termsFormCompleted="handleTermsCompleted" />
            </v-sheet>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useTeamStore, useYearStore } from '@/stores/index';
import { uploadTerms } from '@/controllers';
import { ITeamCriteriaDTO, TeamDTO, UserDTO } from '@/dtos';
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';
import TeamViewComponent from '@/components/teams/TeamViewComponent.vue';
import TeamLeaderCompontent from '@/components/teams/TeamLeaderCompontent.vue';
import TeamLogoCompontent from '@/components/teams/TeamLogoCompontent.vue';
import TermsView from '@/views/user/signup/subviews/SignUpTermsSubView.vue';
import { SNACKSTATUS } from '@/stores/util';
import { useSnack } from '@/helpers';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
const props = defineProps<{ reg: ITeamCriteriaDTO }>();
const teamStore = useTeamStore();
const yearStore = useYearStore();
const showTermsModal = ref<boolean>(props.reg?.force_redo_terms ?? false);

const team = computed(() => {
  return teamStore.myTeam ? teamStore.myTeam : new TeamDTO();
});

const teamId = computed(() => team.value.id);
const yearId = computed(() => yearStore.selectedYearId);
const isTeamEdit = ref(false);

const myReg = computed(() => props.reg);

const { data: leaderData } = teamStore.getTeamLeadQuery(teamId, yearId);
const teamLeader = computed(() => leaderData.value ?? new UserDTO());

const handleLogoUpdated = async () => {
  await teamStore.forceTeamUpdate();
};

const handleTeamEditComplete = () => {
  isTeamEdit.value = false;
};

const handleTermsCompleted = async (value: unknown) => {
  showTermsModal.value = false;
  await uploadTerms(value as Blob);
};
</script>
